import withApplicationProps from '@/evercall/application/withApplicationProps';
import LandingLayout from '@/evercall/ui/common/Layout/LandingLayout';
import Home from '@/evercall/ui/components/Home';

import layoutStyles from '@/evercall/ui/common/Layout/layout.module.scss';

export const getServerSideProps = withApplicationProps(() => ({ props: {} }));

export default (): React.ReactNode => {
  return (
    <LandingLayout containerCls={ layoutStyles.landingHomeContainer }>
      <Home />
    </LandingLayout>
  );
};
